'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { Fragment, useState } from 'react';
import styled from 'styled-components';
import partial from 'transmute/partial';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import breakpoint from '../../utils/responsiveBreakpoints';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OLAF } from 'HubStyleTokens/colors';
import StickyContainer from '../common/StickyContainer';
import { NavItemEnum, SidenavConfig } from '../../constants/Mon569SidenavConfig';
import UIRouterNavLink from 'ui-addon-react-router-dom/UIRouterNavLink';
import { WEB_FONT_REGULAR_WEIGHT, WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import HR from 'UIComponents/elements/HR';
import { useParams } from 'react-router-dom';
const MobileMenuHeading = styled.span.withConfig({
  displayName: "Mon569MobileTabs__MobileMenuHeading",
  componentId: "uffpgr-0"
})(["font-weight:800;display:block;position:relative;overflow:hidden;opacity:0.7;margin-bottom:0.5em;&:first-child{margin-top:0;}&::after{content:'';display:inline-block;background-color:", ";height:1px;position:absolute;top:50%;transform:translate(10px,-50%);width:100%;}"], OLAF);
const MobileMenuBody = styled(UIDialogBody).withConfig({
  displayName: "Mon569MobileTabs__MobileMenuBody",
  componentId: "uffpgr-1"
})(["background-color:#167186;background-image:linear-gradient(to top right,#167186,#167d7a);color:", ";&.pricing-mobile-menu-body{padding:3.4em 1.45em;}"], OLAF);
const MobileMenuBodyInner = styled.div.withConfig({
  displayName: "Mon569MobileTabs__MobileMenuBodyInner",
  componentId: "uffpgr-2"
})(["display:flex;flex-direction:column;padding:40px 0;"]);
const MobileMenuLinkWrapper = styled(UIRouterNavLink).withConfig({
  displayName: "Mon569MobileTabs__MobileMenuLinkWrapper",
  componentId: "uffpgr-3"
})(["position:relative;display:flex;margin:0 auto 1.57em 0;align-items:center;cursor:pointer;:hover{text-decoration:none !important;}> *{font-weight:", ";}&[aria-current='page'] > *{text-decoration:underline;font-weight:", ";}"], WEB_FONT_REGULAR_WEIGHT, WEB_FONT_DEMI_BOLD_WEIGHT);
const MobileMenuLink = styled(FormattedMessage).withConfig({
  displayName: "Mon569MobileTabs__MobileMenuLink",
  componentId: "uffpgr-4"
})(["display:inline-block;font-size:1.57em;line-height:1.4;color:", " !important;"], OLAF);
const MobileMenuCloseButton = styled(UIDialogCloseButton).withConfig({
  displayName: "Mon569MobileTabs__MobileMenuCloseButton",
  componentId: "uffpgr-5"
})(["transform:scale(0.6);right:34px;top:13px;"]);
const MobileMenuTriggers = styled(StickyContainer).withConfig({
  displayName: "Mon569MobileTabs__MobileMenuTriggers",
  componentId: "uffpgr-6"
})(["text-align:center;width:100%;cursor:pointer;background-color:#167186;background-image:linear-gradient(to top right,#167186,#167d7a);color:", ";font-size:1.6em;font-weight:100;padding:0.6em 0.7em 0.86em 0.7em;"], OLAF);
const MobileMenuTriggerLink = styled(FormattedMessage).withConfig({
  displayName: "Mon569MobileTabs__MobileMenuTriggerLink",
  componentId: "uffpgr-7"
})(["display:block;"]);
const MobileMenuTriggerCategory = styled(FormattedMessage).withConfig({
  displayName: "Mon569MobileTabs__MobileMenuTriggerCategory",
  componentId: "uffpgr-8"
})(["font-size:0.515em;letter-spacing:0.5px;margin-bottom:0.515em;opacity:0.7;font-weight:600;"]);
const MobileMenuTriggerIcon = styled(UIIcon).withConfig({
  displayName: "Mon569MobileTabs__MobileMenuTriggerIcon",
  componentId: "uffpgr-9"
})(["transform:scale(0.45) translateY(-50%);position:absolute;right:0.06em;margin:0;top:50%;color:", ";"], OLAF);
const MobileContentContainer = styled.div.withConfig({
  displayName: "Mon569MobileTabs__MobileContentContainer",
  componentId: "uffpgr-10"
})(["display:none;", ""], breakpoint.cs(_t || (_t = _`
    display: block;
  `)));
const StyledHR = styled(HR).withConfig({
  displayName: "Mon569MobileTabs__StyledHR",
  componentId: "uffpgr-11"
})(["transform:translate(0,-50%);"]);

const Mon569MobileTabs = ({
  selectedItem
}) => {
  const [isModalVisible, setModalVisibility] = useState(false);

  const toggleModal = isVisible => setModalVisibility(isVisible);

  const selectedConfig = SidenavConfig[selectedItem];
  const navItems = Object.keys(SidenavConfig);
  const splitIndex = navItems.indexOf('bundle');
  const navLists = [navItems.slice(0, splitIndex), navItems.slice(splitIndex)];
  const {
    tab: selectedTab
  } = useParams();
  return /*#__PURE__*/_jsxs(MobileContentContainer, {
    children: [/*#__PURE__*/_jsxs(MobileMenuTriggers, {
      onClick: partial(toggleModal, true),
      className: "mobile-menu-tab-triggers",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(MobileMenuTriggerCategory, {
          message: selectedConfig.mobileCategory
        }), /*#__PURE__*/_jsx(MobileMenuTriggerLink, {
          message: selectedConfig.title,
          onClick: partial(toggleModal, true)
        })]
      }), /*#__PURE__*/_jsx(MobileMenuTriggerIcon, {
        name: "down",
        size: "sm",
        color: OLAF
      })]
    }), isModalVisible && /*#__PURE__*/_jsxs(UIModal, {
      children: [/*#__PURE__*/_jsx(MobileMenuCloseButton, {
        onClick: partial(toggleModal, false),
        size: "xl"
      }), /*#__PURE__*/_jsx(MobileMenuBody, {
        className: "pricing-mobile-menu-body",
        children: /*#__PURE__*/_jsxs(MobileMenuBodyInner, {
          children: [/*#__PURE__*/_jsx(MobileMenuHeading, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "mon569.sidenav.title"
            })
          }), navLists.map((navList, index) => /*#__PURE__*/_jsxs(Fragment, {
            children: [navList.map(navItem => {
              const hideTabs = navItem === NavItemEnum.BUNDLE || navItem === NavItemEnum.CRM;
              return /*#__PURE__*/_jsx(MobileMenuLinkWrapper, {
                to: `/${SidenavConfig[navItem].id}${hideTabs ? '' : selectedTab ? `/${selectedTab}` : ''}`,
                onClick: partial(toggleModal, false),
                children: /*#__PURE__*/_jsx(MobileMenuLink, {
                  message: SidenavConfig[navItem].title
                })
              }, navItem);
            }), index < navLists.length - 1 && /*#__PURE__*/_jsx(StyledHR, {})]
          }, navList[0]))]
        })
      })]
    })]
  });
};

export default Mon569MobileTabs;